import { render, staticRenderFns } from "./cardTasks.vue?vue&type=template&id=99488636&"
import script from "./cardTasks.vue?vue&type=script&lang=js&"
export * from "./cardTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports